import React, { Component } from 'react';
import instance from "./axios-instance";
import jwt_decode from "jwt-decode";
import Systems from "./SystemFunction";
import { ToastContainer, toast } from 'react-toastify';
let isMobile = false;
if (window.innerWidth <= 760) isMobile = true;

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            categorylist: [],
            activeProviderIndex: 0,
            activeProvider: null,
            loadingProvider: false,
            dropdownOpen: false,

            playerid: null,
            user_id: null,
            username: null,
            point: null,
            loginstate: false,
            firstname: null,
            lastname: null,
            alert: null
        };
    }

    async componentDidMount() {
        this.checklogin();
        await this.getEsportProviderList();
    }

    checklogin = () => {
        var token = localStorage.getItem('auth_token');

        if (token != null) {
            var decoded = jwt_decode(token);

            this.setState({
                user_id: decoded.message.playerid,
                playerid: decoded.message.member_id,
                username: decoded.message.username || decoded.message.Username || decoded.message.playerid,
                firstname: decoded.message.firstname,
                lastname: decoded.message.lastname,
                point: decoded.message.Point,
                loginstate: true
            });
        } else {
            this.setState({
                loginstate: false
            });
        }
    };

    notify = async (mode, msg) => {
        if (mode == "success") {
            await toast.success(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "warning") {
            await toast.warning(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "error") {
            await toast.error(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "info") {
            await toast.info(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
    }

    getProviderName = (item) => {
        return (
            item?.description ||
            item?.Description ||
            item?.proname ||
            item?.providername ||
            item?.ProviderName ||
            item?.name ||
            item?.Name ||
            item?.productname ||
            item?.ProductName ||
            item?.title ||
            item?.Title ||
            "TF Gaming"
        );
    };

    getProviderCode = (item) => {
        return (
            item?.partner ||
            item?.Partner ||
            item?.providercode ||
            item?.provider_code ||
            item?.ProviderCode ||
            item?.code ||
            item?.Code ||
            item?.gamecode ||
            item?.key ||
            ""
        );
    };

    getProviderLogo = (item) => {
        return (
            item?.imagesec ||
            item?.selectimg ||
            item?.logo ||
            item?.Logo ||
            item?.icon ||
            item?.imagepath ||
            item?.img_path ||
            item?.image ||
            item?.Image ||
            item?.img ||
            ""
        );
    };

    getProviderDesc = (item) => {
        return (
            item?.detail ||
            item?.Detail ||
            item?.desc ||
            item?.description ||
            item?.Description ||
            "ผู้ให้บริการ eSportsbook ระดับแนวหน้าในเอเชีย มีตลาดอีสปอร์ตให้เลือกมากมาย ระบบเร็ว เสถียร และรองรับการเดิมพันผ่านทุกอุปกรณ์"
        );
    };

    getProviderSubtitle = (item) => {
        return (
            item?.subtitle ||
            item?.Subtitle ||
            item?.sub_title ||
            "อัตราต่อรองที่เหนือชั้นและการจ่ายเงินที่รวดเร็ว"
        );
    };

    getEsportProviderList = async () => {
        this.setState({ loadingProvider: true });

        await instance.post("/api/v1/tabgamelist", {
            state: "11131",
            System: Systems
        }).then((res) => {
            if (res.data.status === 200) {
                const rows = Array.isArray(res.data.message) ? res.data.message : [];

                this.setState({
                    categorylist: rows,
                    activeProvider: rows.length > 0 ? rows[0] : null,
                    activeProviderIndex: 0
                });
            }
        }).catch((err) => {
            console.log("[ESPORT_PROVIDER_ERROR]", err);

            this.setState({
                categorylist: [],
                activeProvider: null,
                activeProviderIndex: 0
            });
        }).finally(() => {
            this.setState({ loadingProvider: false });
        });
    };

    selectProvider = (item, index) => {
        this.setState({
            activeProvider: item,
            activeProviderIndex: index
        });
    };

    launchProvider = async (e, item = this.state.activeProvider) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        await this.checklogin();

        if (!this.state.loginstate) {
            await this.notify("error", "คุณยังไม่ได้เข้าสู่ระบบ");
            return;
        }

        const partner = this.getProviderCode(item);
        const username = this.state.username || this.state.user_id || this.state.playerid;

        if (!partner) {
            await this.notify("error", "ไม่พบข้อมูลค่ายเกม กรุณาลองใหม่");
            return;
        }

        await instance.post("/api/v1/tablauncher", {
            gameId: "lobby",
            partner: partner,
            playerUsername: username,
            isMobile: isMobile,
            System: Systems,
            demo: false
        }).then((res) => {
            if (res.data.status === 200) {
                const launcher = res.data.message.launcher;

                if (launcher !== undefined) {
                    if (!isMobile) {
                        window.open(launcher.desktop || launcher.mobile, "_blank", "height=1000,width=1000");
                    } else {
                        window.open(launcher.mobile || launcher.desktop);
                    }
                } else {
                    this.notify("error", "ขณะนี้เกมมีปัญหากรุณารอซักครู่");
                }
            } else {
                this.notify("error",  "เปิดเกมไม่สำเร็จ โปรดรอซักครู่เพื่อดำเนินการใหม่");
            }
        }).catch((err) => {
            console.log("[LAUNCH_ESPORT_ERROR]", err);
            this.notify("error", "ขณะนี้เกมมีปัญหากรุณารอซักครู่");
        });
    };

    renderProviderLogo = (item) => {
        const logo = this.getProviderLogo(item);
        const name = this.getProviderName(item);
        const code = this.getProviderCode(item);

        if (logo) {
            return (
                <img
                    src={logo}
                    alt={name}
                    style={{
                        width: 22,
                        height: 22,
                        marginRight: 8,
                        objectFit: "contain"
                    }}
                />
            );
        }

        return (
            <span
                style={{
                    width: 22,
                    height: 22,
                    marginRight: 8,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: 800,
                    fontSize: 11
                }}
            >
                {String(code || name).substring(0, 2)}
            </span>
        );
    };

    renderProviderItem = (item, index) => {
        const name = this.getProviderName(item);
        const code = this.getProviderCode(item);
        const isActive = this.state.activeProviderIndex === index;

        return (
            <li
                key={`${code || name}-${index}`}
                className={`tab-header ${isActive ? "active" : ""}`}
                data-provider-name={name}
                data-provider-code={code}
                onClick={() => this.selectProvider(item, index)}
            >
                {index === 0 ? <p className="float-dot hot-provider">ฮอต</p> : null}

                <div className="tab-inner">
                    {this.renderProviderLogo(item)}
                    <span>{name}</span>
                </div>
            </li>
        );
    };

    renderBenefitBox = (icon, line1, line2, line3 = "") => {
        return (
            <div className="bottom-content-box">
                <picture>
                    <source type="image/webp" srcSet={icon.replace(".png", ".webp")} />
                    <img src={icon} className="bottom-content-icon" alt="" />
                </picture>

                <div className="bottom-content-desc-container">
                    <div className="bottom-content-desc">{line1}</div>
                    <div className="bottom-content-desc">{line2}</div>
                    <div className="bottom-content-desc">{line3}</div>
                </div>
            </div>
        );
    };

    render() {
        const isMobile = window.innerWidth <= 760;
        const { categorylist, activeProvider, activeProviderIndex, loadingProvider } = this.state;

        const currentProvider = activeProvider || (categorylist.length > 0 ? categorylist[0] : null);
        const providerName = currentProvider ? this.getProviderName(currentProvider) : "TF Gaming";
        const providerDesc = currentProvider ? this.getProviderDesc(currentProvider) : "TF Gaming ได้รับการพัฒนาโดยทีมนักพัฒนา ESports โดยเฉพาะและเจ้ามือรับแทงที่มีประสบการณ์ เป้าหมายของเราคือการจัดหาแพลตฟอร์ม ESports ที่ไม่เหมือนใครและสะดวกสบายสำหรับทุกคน";
        const providerSubtitle = currentProvider ? this.getProviderSubtitle(currentProvider) : "อัตราต่อรองที่เหนือชั้นและการจ่ายเงินที่รวดเร็ว";

        /* ─── MOBILE LAYOUT ─── */
        if (isMobile) {
            const { dropdownOpen } = this.state;

            return (
                <div className="slots-mobile-wrapper" onClick={() => dropdownOpen && this.setState({ dropdownOpen: false })}>

                    {/* ── Header: ← | provider dropdown ↓ | เล่น ── */}
                    <div className="slots-mobile-header">

                        {/* Back button — SVG chevron */}
                        <button
                            className="slots-mobile-back"
                            onClick={(e) => { e.stopPropagation(); window.history.back(); }}
                            aria-label="back"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="15 18 9 12 15 6" />
                            </svg>
                        </button>

                        {/* Provider dropdown */}
                        <div
                            className="esport-provider-dropdown-wrapper"
                            onClick={(e) => { e.stopPropagation(); this.setState({ dropdownOpen: !dropdownOpen }); }}
                        >
                            <div id="dropdownBtn" className={`standard-select${dropdownOpen ? ' isOpen' : ''}`}>
                                <span className="casino-mobile-provider-name">{providerName}</span>
                                <span className="standard-select-arrow">&#9660;</span>
                            </div>

                            {/* Dropdown list */}
                            {dropdownOpen && categorylist.length > 0 && (
                                <div className="esport-provider-dropdown-list">
                                    {categorylist.map((item, index) => {
                                        const name = this.getProviderName(item);
                                        const isActive = activeProviderIndex === index;
                                        return (
                                            <div
                                                key={index}
                                                className={`esport-dropdown-item${isActive ? ' active' : ''}`}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.selectProvider(item, index);
                                                    this.setState({ dropdownOpen: false });
                                                }}
                                            >
                                                {this.renderProviderLogo(item)}
                                                <span>{name}</span>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>

                        {/* Play button on right */}
                        <button
                            className="esport-header-play-btn"
                            onClick={(e) => { e.stopPropagation(); this.launchProvider(e, currentProvider); }}
                        >
                            เล่น
                        </button>
                    </div>

                    {/* Provider info + play button */}
                    <div className="esport-mobile-info">
                        <p className="esport-mobile-title">{providerName}</p>
                        <p className="esport-mobile-desc">{providerSubtitle}</p>
                        <button
                            type="button"
                            className="esport-mobile-play-btn"
                            onClick={(e) => this.launchProvider(e, currentProvider)}
                        >
                            เล่นตอนนี้
                        </button>
                    </div>

                    {/* Description */}
                    <div className="esport-mobile-body">
                        <p className="esport-mobile-body-text">{providerDesc}</p>
                    </div>

                    {/* เกม Esport — game logos section */}
                    <div className="esport-mobile-games-section">
                        <div className="esport-mobile-games-header">
                            <p className="esport-mobile-games-title">เกม Esport</p>
                            <p className="esport-mobile-games-subtitle">ผู้เล่นหลายคนให้ความนิยมเป็นจำนวนมาก</p>
                        </div>
                        <div className="esport-mobile-games-img">
                            <picture>
                                <source type="image/webp" srcSet="/build/web/igame-index-lobby-wm/img/esport-game-logo.webp" />
                                <img
                                    src="/build/web/igame-index-lobby-wm/img/esport-game-logo.png"
                                    className="esport-game-mobile"
                                    alt=""
                                    style={{ width: "100%", display: "block" }}
                                />
                            </picture>
                        </div>
                    </div>
                </div>
            );
        }

        /* ─── DESKTOP LAYOUT ─── */
        return (
            <>
                <div className="providerLandingIndexContainer esport-container">
                    <div className="_productBannerContainer_1ma75_1 product-banner-container">
                        <div className="slick-slider slider slick-initialized">
                            <div className="slick-list">
                                <div
                                    className="slick-track"
                                    style={{
                                        width: "100%",
                                        opacity: 1,
                                        transform: "translate3d(0px, 0px, 0px)"
                                    }}
                                >
                                    <div
                                        data-index={0}
                                        className="slick-slide slick-active slick-current"
                                        tabIndex={-1}
                                        aria-hidden="false"
                                        style={{
                                            outline: "none",
                                            width: "100%"
                                        }}
                                    >
                                        <div>
                                            <div
                                                className="_productBannerWrapper_1ma75_1 top top-provider-img"
                                                tabIndex={-1}
                                                style={{
                                                    width: "100%",
                                                    display: "inline-block"
                                                }}
                                            >
                                                <img
                                                    loading="lazy"
                                                    src="https://s3.newworld.center/image/902ed23b-82f3-438a-b950-34abbb03f53f.webp"
                                                    className="_productBanner_1ma75_1 provider-banner"
                                                    alt="banner-img"
                                                />

                                                <div className="_content_1ma75_25 top-provider-content ">
                                                    <p className="_title_1ma75_48 provider-type">สนามกีฬาอีสปอร์ต</p>

                                                    <div className="_desc_1ma75_58 provider-desc">
                                                        <h4>ผู้ให้บริการ eSportsbook อันดับ 1</h4>
                                                        <h5>ในเอเชียที่มีให้เลือกมากมาย</h5>
                                                    </div>
                                                </div>

                                                <div className="bk8-logo-container">
                                                    <div className="logo-img" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mid" id="provider-box">
                        <ul className="provider-box">
                            {loadingProvider ? (
                                <li className="tab-header active">
                                    <div className="tab-inner">
                                        <span>กำลังโหลดค่ายเกม</span>
                                    </div>
                                </li>
                            ) : categorylist.length > 0 ? (
                                categorylist.map((item, index) => this.renderProviderItem(item, index))
                            ) : (
                                <li
                                    className="tab-header active"
                                    data-provider-name="TFG"
                                    data-provider-code="TF"
                                >
                                    <p className="float-dot hot-provider">ฮอต</p>
                                    <div className="tab-inner">
                                        <span>TF Gaming</span>
                                    </div>
                                </li>
                            )}
                        </ul>
                    </div>

                    <div className="bottom-category benefit">
                        <div className="bottom-content">
                            <div className="title">{providerName}</div>

                            <div className="subtitle">
                                {providerSubtitle}
                            </div>

                            <div className="description">
                                {providerDesc}
                            </div>

                            <button
                                type="button"
                                onClick={(e) => this.launchProvider(e, currentProvider)}
                            >
                                เล่นตอนนี้
                            </button>
                        </div>

                        <div className="bottom-content-container">
                            <div className="bottom-content-wrapper">
                                {this.renderBenefitBox(
                                    "/build/web/igame-index-lobby-wm/img/tfg-icon-1.png",
                                    "อัตราต่อรองที่เหนือชั้น",
                                    "การจ่ายเงินที่รวดเร็ว"
                                )}

                                {this.renderBenefitBox(
                                    "/build/web/igame-index-lobby-wm/img/tfg-icon-2.png",
                                    "อีสปอร์ตเทรดเดอร์",
                                    "มีประสบการณ์และ",
                                    "เป็นมืออาชีพ"
                                )}

                                {this.renderBenefitBox(
                                    "/build/web/igame-index-lobby-wm/img/tfg-icon-3.png",
                                    "ตลาดอีสปอร์ต",
                                    "มีให้เลือกมากมาย"
                                )}

                                {this.renderBenefitBox(
                                    "/build/web/igame-index-lobby-wm/img/tfg-icon-4.png",
                                    "ระบบเร็วและเสถียร",
                                    "ความเร็วเดิมพันสองเท่า"
                                )}

                                {this.renderBenefitBox(
                                    "/build/web/igame-index-lobby-wm/img/tfg-icon-5.png",
                                    "รองรับพีซี มือถือ",
                                    "โทรศัพท์และแท็บเล็ต"
                                )}

                                {this.renderBenefitBox(
                                    "/build/web/igame-index-lobby-wm/img/tfg-icon-6.png",
                                    "ผู้นำอุตสาหกรรม",
                                    "ประสบการณ์เดิมพัน"
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="bottom-category esport-desc">
                        <div className="bottom-content">
                            <div className="title">เกม Esport</div>

                            <div className="subtitle">
                                ผู้เล่นหลายคนให้ความนิยมเป็นจำนวนมาก
                            </div>
                        </div>

                        <div className="bottom-content-img">
                            <picture>
                                <source
                                    type="image/webp"
                                    srcSet="/build/web/igame-index-lobby-wm/img/esport-game-logo.webp"
                                />
                                <img
                                    src="/build/web/igame-index-lobby-wm/img/esport-game-logo.png"
                                    className="esport-game"
                                    alt=""
                                />
                            </picture>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default App;